export default "__VITE_ASSET__D22FmqMb__"